<template>
  <v-card elevation="1" class="mb-4" v-if="isProductCompany()">
    <v-card-text>
      <h6 class="text-h6 black--text">Stock</h6>
      <p class="text-body-2">Indique si el remito egresa mercadería del stock</p>

      <v-row>
        <v-col md="6">
          <v-radio-group 
            data-vv-as="remito incluye stock" 
            name="stock_remito" 
            v-model="remito.stock_remito" 
            row 
            @change="changeIncludeStock()" 
            v-validate="'required'" 
            :disabled="isViewModal"
          >
            <v-radio label="Con stock" :value="true" color="primary"></v-radio>
            <v-radio label="Sin stock" :value="false" color="primary"></v-radio>
          </v-radio-group>
          <span class="red--text">{{ errors.first("stock_remito") }}</span>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col md="6" v-if="remito.stock_remito != null && remito.stock_remito">
          <v-combobox
            v-model="remito.warehouse"
            data-vv-as="deposito"
            name="warehouse"
            item-text="name"
            item-value="id"
            :items="warehouses"
            label="Deposito*"
            :v-validate="isRequired()"
            autocomplete="off"
            :disabled="isViewModal"
            v-validate="'required|combobox_required'"
          ></v-combobox>
          <span class="red--text">{{ errors.first("warehouse") }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Constant from "@/constants/sections";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import { generalService } from "@/libs/ws/generalService";

export default {
  mixins: [SettingsMixin],
  props: {
    remito: { type: Object, required: true },
    isViewModal: { type: Boolean, default: false },
  },
  data() {
    return {
      warehouses: [],
      default_warehouse: null,
    };
  },
  mounted() {
    this.loadComboData();
  },
  watch: {
    remito: {
      handler: function (val) {
        if (val.stock_remito && val.warehouse == null && this.default_warehouse != null) {
          this.remito.warehouse = this.default_warehouse;
        }
      },
      deep: true,
    },
  },
  methods: {
    changeIncludeStock() {
      if (this.remito.stock_remito && this.remito.warehouse == null && this.default_warehouse != null) {
        this.remito.warehouse = this.default_warehouse;
      }
    },
    isRequired() {
      return this.remito.stock_remito != null && this.remito.stock_remito;
    },
    loadComboData() {
      generalService.setSection(Constant.SECTION_WAREHOUSES);
      generalService
        .filter()
        .then((response) => {
          this.warehouses = response.result;
          if (this.warehouses.length > 0) {
            this.default_warehouse = this.warehouses.find((w) => w.is_default);
            if (this.default_warehouse == null && this.warehouses.length > 0) {
              this.default_warehouse = this.warehouses[0];
            }
          }
        })
        .catch((e) => {
          console.log("warehouses.filter error");
          console.log(e);
        });
    },
  },
};
</script>
